import { Colors } from "@/enums/Colors";
import { Menu, MenuProps, alpha, styled } from "@mui/material";

export const CommonStyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiTypography-root": {
    fontWeight: "500",
  },
  "& .MuiPaper-root": {
    border: `1px solid ${Colors.LIGHT_GRAY}`,
    borderRadius: 8,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: Colors.LIGHT_GRAY_8E8EA0,
    boxShadow: "0px 1px 4px 0px #00000040",
    "& .MuiMenu-list": {
      padding: "0",
    },
    "& .MuiMenuItem-root": {
      paddingLeft: "1.4rem",
      "& .MuiSvgIcon-root": {
        fontSize: 22,
        marginRight: theme.spacing(1.5),
      },
      "&.Mui-focusVisible": {
        backgroundColor: alpha(Colors.ALMOST_WHITE, 1),
      },
    },
  },
}));
